<template>
	<div class="section">
		<div class="contacts container">
			<div v-html="description" class="contacts__title"></div>
			<div class="contacts__card" :class="{ 'contacts__card--small': displaySmall }">
				<template v-if="!displaySmall">
					<Card
						v-for="(contact, index) in contentComp"
						:key="index + 'contact'"
						:item="contact"
						cover-height="392px"
						responsive-cover-height="392px"
						:show-hover-state="false"
						class="col"
					>
						<Person :value="contact" />
					</Card>
				</template>
				<template v-else>
					<div v-for="(contact, index) in contentComp" :key="index + 'contact'" class="contacts__card-small">
						<Card :item="contact" cover-height="392px" responsive-cover-height="392px" :show-hover-state="false">
						</Card>
						<Person class="contacts__info" :value="contact" />
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import Card from '@/components/Card'
import Marked from 'marked'
import Person from '@/components/Person.vue'
export default {
	props: {
		content: {
			type: Object,
			default: () => ({}),
		},
	},
	computed: {
		contentComp() {
			return this.content.contacts.map(element => {
				return {
					url: element.cover.url,
					focalPoint: element.cover.focalPoint,
					name: element.name,
					email: element.email,
					phone: element.phone,
					role: element.role,
				}
			})
		},
		displaySmall() {
			return this.content.contacts.length <= 2
		},
		description() {
			return Marked(this.content.title, true)
		},
	},
	components: {
		Card,
		Person,
	},
}
</script>

<style lang="scss">
@import '@/styles/base/_variables.scss';
@import '@/styles/utils/_mixins.scss';

.contacts {
	&__title {
		text-align: center;
		text-align: center;
		padding: 0 0 3rem;
	}
	&__card {
		display: grid;
		grid-gap: 4rem 0.5rem;
		grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));
		padding: 0 0.5rem;
		&--small {
			grid-gap: 4rem 3rem;
		}

		&-small {
			display: grid;
			grid-gap: 0rem 0.5rem;
			grid-template-columns: repeat(auto-fit, minmax(230px, 1fr));

			align-items: flex-end;
			background-color: $secondary !important;

			@include respond-below('phone') {
				grid-gap: 2rem;
			}

			.card__cover {
				color: $primary !important;
			}
			.person {
				color: $primary !important;
			}
			.contacts__info {
				color: $primary !important;
				background-color: $secondary !important;
				padding: 0 2rem 2rem;
			}
		}
	}
}
</style>
